import React, { useEffect } from 'react';
import { DraggableComponentProps } from 'features/document/constants';
import { Box, Typography } from '@mui/material';
import { isContactInfoElement } from 'utils/typeGuards';
import { parseJustifyContentToAlignment } from 'utils/alignmentParsers';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { updateElementById } from 'features/document/documentSlice';
import { selectQuote } from 'features/salesforce/salesforceSlice';

export default function ContactInfo({ currentElement }: DraggableComponentProps) {
  if (!isContactInfoElement(currentElement)) {
    return null;
  }

  const dispatch = useAppDispatch();
  const quote = useAppSelector(selectQuote);

  const { name, number, email, fax } = currentElement.content;
  const { justifyContent } = currentElement.style;
  const alignment = parseJustifyContentToAlignment(justifyContent);

  useEffect(() => {
    const { ContactName, Phone, Email, Fax } = quote;
    const newContactInfo = {
      name: ContactName,
      number: Phone,
      email: Email,
      fax: Fax,
    };
    dispatch(
      updateElementById({
        elementId: currentElement.id,
        content: newContactInfo,
        style: {},
      })
    );
  }, [dispatch, quote]);

  return (
    <Box
      alignItems={justifyContent}
      display={'flex'}
      justifyContent={'center'}
      flexDirection={'column'}
      padding={'8px'}
      width={'100%'}
    >
      <Typography sx={{ textAlign: alignment }} fontSize={'16px'} fontWeight={'500'}>
        Contact Info
      </Typography>
      <Typography sx={{ textAlign: alignment }} fontSize={'16px'} flexWrap={'wrap'}>
        {name || 'Name'}
      </Typography>
      <Typography sx={{ textAlign: alignment }} fontSize={'16px'} flexWrap={'wrap'}>
        {number || 'Phone Number'}
      </Typography>
      <Typography sx={{ textAlign: alignment }} fontSize={'16px'} flexWrap={'wrap'}>
        {email || 'Email'}
      </Typography>
      <Typography sx={{ textAlign: alignment }} fontSize={'16px'} flexWrap={'wrap'}>
        {fax || 'Fax'}
      </Typography>
    </Box>
  );
}
